import { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import { rbp } from '@/constants/measured-scope'
import { UserStats as UserStatistics } from '@/shared/api-generated-types'
import { useMediaQuery } from '@react-hookz/web'
import { useTranslation } from 'next-i18next'
import React from 'react'
import * as styles from './style'

interface Props {
  stats: UserStatistics
  hide?: boolean
  isPartnerView?: boolean
}

export const Divider = (): JSX.Element => <hr className={styles.divider} />

const UserStats: React.FC<Props> = ({ stats, hide, isPartnerView }) => {
  const { t } = useTranslation('common')
  const isLargeDevice = useMediaQuery(`only screen and (min-width : ${rbp.tablet})`, { initializeWithValue: false })
  const isSmallTablet = useMediaQuery(`only screen and (max-width : ${rbp.tablet})`, { initializeWithValue: false })

  if (hide) {
    return null
  }

  return (
    <div>
      {isPartnerView && isLargeDevice ? (
        <div className={`${styles.root} ${styles.rootPartner}`}>
          <div className={styles.container}>
            <Stack x>
              <Stack x alignItems="center">
                <Text size="md" responsiveSize={{ lg: 'xs' }} weight="lg" className="mr-xxs">
                  {stats.formattedActiveDays}
                </Text>
                <Text size="xxs" responsiveSize={{ lg: 'xs' }} weight="sm" tag="p">
                  {t('userStats.activeDays')}
                </Text>
              </Stack>
            </Stack>
          </div>
          <Divider />
          <div className={styles.container}>
            <Stack x>
              <Stack x alignItems="center">
                <Text size="md" responsiveSize={{ lg: 'xs' }} weight="lg" className="mr-xxs">
                  {stats.formattedTotalBookings}
                </Text>
                <Text size="xxs" responsiveSize={{ lg: 'xs' }} weight="sm" tag="p">
                  {t('userStats.classesBooked')}
                </Text>
              </Stack>
            </Stack>
          </div>
          <Divider />
          <div className={styles.container}>
            <Stack x>
              <Stack x alignItems="center">
                <Text size="md" responsiveSize={{ lg: 'xs' }} weight="lg" className="mr-xxs">
                  {stats.formattedTotalMinutes}
                </Text>
                {isSmallTablet ? (
                  <Text size="xxs" responsiveSize={{ lg: 'xs' }} weight="sm" tag="p">
                    {t('userStats.wellnessMins')}
                  </Text>
                ) : (
                  <Text size="xxs" responsiveSize={{ lg: 'xs' }} weight="sm" tag="p">
                    {t('userStats.wellnessMinutes')}
                  </Text>
                )}
              </Stack>
            </Stack>
          </div>
        </div>
      ) : (
        <div className={styles.root}>
          <div className={styles.container}>
            <Stack x>
              <Stack y>
                <Text size="md" responsiveSize={{ sm: 'lg', lg: 'xl' }} weight="lg">
                  {stats.formattedActiveDays}
                </Text>
                <Text size="xxs" responsiveSize={{ lg: 'xs' }} weight="sm" tag="p">
                  {t('userStats.activeDays')}
                </Text>
              </Stack>
            </Stack>
          </div>
          <Divider />
          <div className={styles.container}>
            <Stack x>
              <Stack y>
                <Text size="md" responsiveSize={{ sm: 'lg', lg: 'xl' }} weight="lg">
                  {stats.formattedTotalBookings}
                </Text>
                <Text size="xxs" responsiveSize={{ lg: 'xs' }} weight="sm" tag="p">
                  {t('userStats.classesBooked')}
                </Text>
              </Stack>
            </Stack>
          </div>
          <Divider />
          <div className={styles.container}>
            <Stack x>
              <Stack y>
                <Text size="md" responsiveSize={{ sm: 'lg', lg: 'xl' }} weight="lg">
                  {stats.formattedTotalMinutes}
                </Text>
                {isSmallTablet ? (
                  <Text size="xxs" responsiveSize={{ lg: 'xs' }} weight="sm" tag="p">
                    {t('userStats.wellnessMins')}
                  </Text>
                ) : (
                  <Text size="xxs" responsiveSize={{ lg: 'xs' }} weight="sm" tag="p">
                    {t('userStats.wellnessMinutes')}
                  </Text>
                )}
              </Stack>
            </Stack>
          </div>
        </div>
      )}
    </div>
  )
}

export default UserStats
